import { type FocusEvent } from 'react';
import { type Control, type FieldErrors, type UseFormResetField } from 'react-hook-form';

import { type CardOptionType, useTranslate } from 'hooks';
import { useAppSelector } from 'store/hooks';
import { twMergeClsx } from 'utils';

import CvvInput from './cvv-input';
import DateInput from './date-input';
import PanInput from './pan-input';
import { type CardFieldsType } from './type';

type CardDetailsType = {
  control: Control<CardFieldsType, any>;
  selectedCard: CardOptionType;
  cardNumber: string;
  errors: FieldErrors<CardFieldsType>;
  focusName: keyof CardFieldsType;
  onHandleFocus: (e: FocusEvent<HTMLInputElement>) => void;
  resetField: UseFormResetField<CardFieldsType>;
};

const CardDetails = ({
  control,
  selectedCard,
  cardNumber,
  errors,
  focusName,
  onHandleFocus,
  resetField,
}: CardDetailsType) => {
  const { paymentData, amount, isPayment } = useAppSelector((state) => state.payment);
  const { t } = useTranslate();

  return paymentData ? (
    <div className="flex flex-col gap-5">
      <PanInput
        amount={amount}
        cardNumber={cardNumber}
        control={control}
        onHandleFocus={onHandleFocus}
        paymentData={paymentData}
        resetField={resetField}
        selectedCard={selectedCard}
      />
      {isPayment ? (
        <div>
          <div
            className={twMergeClsx(
              'text-sm leading-[18px] font-medium mb-1.5 block whitespace-nowrap text-fonbet-gray-200',
              (focusName === 'month' || focusName === 'year' || focusName === 'cvv') &&
                'text-fonbet-blue-200',
            )}
          >
            {t('fonbet.date-cvv.label')}
          </div>
          <div className="flex gap-3 lg:mt-0">
            <DateInput
              amount={amount}
              control={control}
              errors={errors}
              onHandleFocus={onHandleFocus}
              paymentData={paymentData}
              selectedCard={selectedCard}
              resetField={resetField}
            />
            <CvvInput
              amount={amount}
              control={control}
              onHandleFocus={onHandleFocus}
              paymentData={paymentData}
              selectedCard={selectedCard}
            />
          </div>
        </div>
      ) : null}
    </div>
  ) : null;
};

export { CardDetails };
